import { render, staticRenderFns } from "./BaseNavDetail.vue?vue&type=template&id=4c0be3de"
import script from "./BaseNavDetail.vue?vue&type=script&lang=js"
export * from "./BaseNavDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports